import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscGlyph = /*#__PURE__*/createElement("g", {
  id: "misc"
}, /*#__PURE__*/createElement("path", {
  d: "M69.5,26.9c0-1.6-1-3-2.4-3.6l0,0l-0.1,0c0,0,0,0,0,0l-0.1,0L44.5,14l-0.1,0l0,0c-1.6-0.6-3.3-0.6-4.8,0l0,0l-0.1,0 c0,0,0,0,0,0l-0.1,0l0,0l-22.5,9.2l0,0c-1.4,0.6-2.4,2-2.4,3.6h0V27v0.1v29.7V57v0.1h0c0,1.6,1,3,2.4,3.6l0,0l22.5,9.2l0,0l0.1,0 l0.1,0l0,0c0.8,0.3,1.6,0.5,2.4,0.5c0.8,0,1.6-0.2,2.4-0.5l0,0l0.2-0.1l0,0l0,0l22.2-9.1l0,0l0.1,0l0.1,0l0,0 c1.4-0.6,2.4-2,2.4-3.6h0V57v-0.1V27.1V27L69.5,26.9L69.5,26.9z M64.7,25.5l-21.4,8.3c-0.9,0.3-1.8,0.3-2.7,0l-0.1,0l-21.3-8.3 l21.3-8.7c0.9-0.4,1.9-0.4,2.8,0l0.1,0L64.7,25.5z M66.6,57c0,0.5-0.3,0.9-0.7,1l-0.1,0l0,0l0,0l-22.2,9.1l0,0l0,0v-24v-0.1v-0.1 h0c-0.1-0.8-0.7-1.4-1.5-1.4c-0.8,0-1.4,0.6-1.5,1.4h0v0.1v0.1v24l-22.3-9.1l0,0l-0.1,0c-0.4-0.2-0.7-0.6-0.7-1v-0.1V28l22.1,8.6 l0.1,0l0,0c0.7,0.3,1.5,0.4,2.3,0.4c0.8,0,1.6-0.1,2.3-0.4l0,0l0.1,0c0,0,0,0,0,0l0.1,0l0,0l22-8.5v28.8V57z"
}));
const Misc = createSvg({
  name: 'Miscellaneous',
  path: MiscGlyph
});

export default Misc;
export { MiscGlyph };
